<template>
    <div class="openpointsstatus">
        <b-card :key="pstates" _title="Issues - Status">
            <b-row v-for="r in rows" :key="r" class="stati">
                <b-col cols="6">
                    <template v-if="states.length">
                        <div class=pallino :style="`width: 20px;height: 20px;background-color: ${states[r].color};border-radius: 50%;margin:10px;border: 2px solid black;`"></div>
                        <div class="descr">{{ states[r].descr }}</div>
                        <div class="num">{{ states[r].k }}</div>
                    </template>
                    <hr>
                </b-col>
                <b-col cols="6">
                    <template v-if="states.length">
                        <div class=pallino :style="`width: 20px;height: 20px;background-color: ${states[r + 1].color};border-radius: 50%;margin:10px;border: 2px solid black;`"></div>
                        <div class="descr">{{ states[r + 1].descr }}</div>
                        <div class="num">{{ states[r + 1].k }}</div>
                    </template>
                    <hr>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { API } from "@/api.js";

export default {
    data: function () {
        return {
            states: [],
            rows: [0, 2],
        };
    },
    name: "OpenPointsStatus",
    props: {
        filtro: { type: Array, default: null }
    },
    async mounted() {
        await this.getIssues()
        console.log("mounted states:", this.states);
    },
    async beforeUpdate() {
        // this.states = await API.issueStates(this.m ? this.m.codice : null);
        console.log("beforeupdate states:", this.states);
    },
    computed: {
        pstates() {
            return this.$store.getters.pstates
        },
        section(){
            return this.$store.getters.section
        },
        machine(){
            return this.$store.getters.machine
        },
    },
    watch: {
        filtro: {
            handler: async function (val) {
                console.log("filter changed",val)
                this.getIssues()
            },
            immediate: true
        },
        async pstates() {
            this.states = await API.issueStates(this.m ? this.m.codice : null);
        }
    },
	methods: {
        async getIssues(){
            this.states = await API.issueStates(this.machine ? this.machine.codice : null, this.section, this.filtro);
        }
    },
};
</script>

<style scoped>
div.pallino {
    float: left;
}

div.descr {
    float: left;
    position: relative;
    top: 7px;
    margin-left: 20px;
}

div.num {
    float: right;
    position: relative;
    top: 7px;
    font-weight: 700;
}

hr {
    position: relative;
    top: 20px;
}
</style>
